<template>
    <UiCoreSimpleTitle
        v-editable="blok"
        class="sb-core-simple-title sps"
        data-test="sb-core-simple-title"
        :blok="blok"
    />
</template>

<script setup lang="ts">
import type { ICoreSimpleTitle } from '~ui/types';

defineProps<{ blok: ICoreSimpleTitle }>();
</script>

<style scoped lang="postcss">
.sb-core-simple-title.sps {
    :deep(.has-divider) {
        @apply relative pb-5;
        &:before {
            @apply content-[""] w-9 h-[3px] ml-[-18px] absolute bg-[#055988] mr-0 my-0 left-2/4 bottom-px;
        }
        &:after {
            @apply content-[""] absolute bg-[#055988] w-[164px] h-px ml-[-82px] mr-0 my-0 left-2/4 bottom-0.5;
        }
    }
    :deep(.no-font-size h1) {
        @apply md:text-4xl text-[1.75rem];
    }
}
</style>
